import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { AuthProvider } from '@/auth/AuthContext';
import { AdminShell } from '@/components/AdminShell';
import AuthCallbackPage from '@/pages/AuthCallbackPage';
import OverviewPage from '@/pages/OverviewPage';
import SignedOutPage from '@/pages/SignedOutPage';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false } } });

export default function App() {
  return <QueryClientProvider client={queryClient}><BrowserRouter><Routes>
    <Route path="/auth/callback" element={<AuthCallbackPage />} />
    <Route path="/auth/signed-out" element={<SignedOutPage />} />
    <Route path="*" element={<AuthProvider><AdminShell><OverviewPage /></AdminShell></AuthProvider>} />
  </Routes></BrowserRouter></QueryClientProvider>;
}
